import React from 'react';

const recipeConfirmation = ({ firstName = '' } = {}) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a',
      }}
    >
      Great News {firstName}! Your resource is on its way to your mailbox.
    </h2>
    <br></br>
    <div>
      <p>
      We praise God for your heart to serve others through Gospel-centered kindness and hospitality. It’s our prayer that this resource will encourage you to <em>“serve one another humbly in love”</em> (Galatians 5:13, NIV).
      </p>
    </div>
  </div>
);

export default recipeConfirmation;
